/**
 * OrbDocReferenceOperatorsAROrbDocReferenceOperatorsARPage
 *
 * Page component for OrbDocReferenceOperatorsAROrbDocReferenceOperatorsARPage
 * Path: /ar/docs/reference/operators
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocReferenceOperatorsARDocScreenView as __OrbDocReferenceOperatorsARDocScreenView } from '@/components/traits/OrbDocReferenceOperatorsARDocScreenView';
import { OrbDocReferenceOperatorsARDocAnalyticsView as __OrbDocReferenceOperatorsARDocAnalyticsView } from '@/components/traits/OrbDocReferenceOperatorsARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocReferenceOperatorsAROrbDocReferenceOperatorsARPageProps {
  // Add any page-level props here
}

export function OrbDocReferenceOperatorsAROrbDocReferenceOperatorsARPage(_props: OrbDocReferenceOperatorsAROrbDocReferenceOperatorsARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"العوامل","description":"كل عامل يستطيع برنامج .lolo استدعاءه، من السجل المعتمد الذي يضمّنه المترجم.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/reference/operators"},{"locale":"ar","path":"/ar/docs/reference/operators"},{"locale":"sl","path":"/sl/docs/reference/operators"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocReferenceOperatorsARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocReferenceOperatorsARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocReferenceOperatorsAROrbDocReferenceOperatorsARPage;
